
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css-variables.css'
import './assets/main.css'

import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { checkSentryHealth, initializeSentry, setSentryUser } from './utils/sentry'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import App from './App.vue'
import router from './router'
import BackButton from './components/common/BackButton.vue'
import { useAuthStore } from './stores/auth'
import { useNotificationStore } from './stores/notifications'

library.add(fas, fab)

const initApp = async () => {
  const app = createApp(App)
  const pinia = createPinia()

  app.use(pinia)
  app.use(router)

  const sentryIsAlive = await checkSentryHealth()
  
  if (sentryIsAlive) {
    initializeSentry(app, router, pinia)
  }

  const authStore = useAuthStore()
  if (sentryIsAlive && authStore.user) {
    setSentryUser(authStore.user)
  }

  // Benachrichtigungen initialisieren wenn Benutzer eingeloggt ist
  if (authStore.user) {
    const notificationStore = useNotificationStore()
    await notificationStore.initializeNotifications()
  }

  app.component('font-awesome-icon', FontAwesomeIcon)
  app.component('BackButton', BackButton)
  app.mount('#app')
}

initApp()
